import instObj from '@/backend/axios-instances'

const resource = "/cutsheets/parts"
const instance = instObj.baseInstance
// need cutsheetpart_id as a param for every call

export default {
  get(parameters) {
    return instance.get(`${resource}/steps`, { params: parameters });
  },
  put(stepId, data, parameters) {
    return instance.put(`${resource}/step/${stepId}`, data, { params: parameters });
  },
  post(data, parameters) {
    return instance.post(`${resource}/steps`, data, { params: parameters });
  },
  delete(stepId, parameters) {
    return instance.delete(`${resource}/step/${stepId}`, { params: parameters });
  }
}